import {ElementsValues} from "@data-force/app";
import Nullable from "@data-force/app/interfaces/nullable";
import {TranslateFunction} from "react-localize-redux";
import {Cursor} from "./cursor";

export enum Status {
    NEW = "NEW",
    NOT_STARTED = "NOT_STARTED",
    READY = "READY",
    IN_PROGRESS = "IN_PROGRESS",
    COMPLETED = "COMPLETED",
    SKIPPED = "SKIPPED",
    FAILED = "FAILED",
    REOPENED = "REOPENED",
    REJECTED = "REJECTED",
}

export interface TaskPhase {
    dateStarted?: number
    name: string
    status: Status
}

export interface TaskEntity {
    batchId: string
    id: string
    jobId: string
    name: string
    payload: string
    phaseStatuses: string
    phases: TaskPhase[]
    projectId: string
    projectType: string
    status: Status
    version: number
    workflowDefinitionId: string
}

export interface Task {
    id: string
    name: string
    finished?: boolean
    version: number
    valid?: boolean
    data?: TaskData
}

export interface TaskListResponse {
    cursor?: Cursor
    items?: TaskEntity[]
}

export interface GetTaskListPayload {
    cursor?: Cursor
    movement?: 1 | -1
    preventScroll?: boolean
}

export interface ChangeActiveTask {
    id: string
    movement: 1 | -1
}

export type TaskDataType = string | number | boolean | string[] | number[] | boolean[] | string[][] | number[][] | null;

export interface TaskData {
    [key: string]: TaskDataType
}

export interface ActiveTaskPrivates {
    signedMediaUrl?: Nullable<string>
    fileName?: Nullable<string>
    upload?: Nullable<string>
    saveInProgress?: boolean
}

export interface GetTaskResponse {
    id: string
    name: string
    finished?: boolean
    version: number
    valid?: boolean
    data?: ElementsValues
}

export enum CompleteType {
    SINGLE = "SINGLE",
    BULK = "BULK",
}

export interface CompleteIntakePayload {
    event: string
    isRetry: boolean
    completeType: CompleteType
    taskList: TaskEntity[]
    isSubmitAfterExpiry?: boolean
}

export interface UpdateActiveTask {
    activeTaskUpdate: Partial<Task>
}

export interface TaskMaskData {
    visible: boolean
}

export type StatusStats = {
    [key in Status]?: number
};

export interface FetchTaskMetadataPayload {
    taskId: string
    token: string
    schemaKey: string
}

export interface StatusIconInfo {
    status: Status
    isActiveTask: boolean
    activeTaskInvalid: boolean
    validTask: boolean
    translationPath: string
    translate: TranslateFunction
}

export interface StatusIconData {
    statusClass: string
    statusName: string
}

export interface TaskCompletionData {
    event: string
    completeType: CompleteType
    isRetry: boolean
}

export interface CompleteIntakeData {
    event: string
    phase: string
    taskIds?: string[]
}

export type StatusFrequencies = {
    [key in Status]: number
};
